var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loginBtn",staticClass:"kkday-auth-svc-login-button",on:{"click":_vm.onClick}},[_c('div',{staticClass:"button-icon"}),_c('div',{staticClass:"button-text",domProps:{"textContent":_vm._s(_vm.buttonText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }